import { MembersTab as Layout } from 'ui-components'

import { InviteMemberDialog } from './InviteMemberDialog'
import { MemberList } from './MemberList'
import { MembersTabTools } from './MembersTabTools'

const Members = () => {
  return (
    <Layout
      slots={{
        InviteMemberDialog,
        MembersTabTools,
        MemberList
      }}
    />
  )
}

export { Members }
export default Members
